import React from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { Create } from "react-admin";
import { useNavigate } from "react-router-dom";

import { DishCategoryTagService } from "../../services/DishCategoryTagService";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import DishCategoryIconUploader from "./DishCategoryIconUploader";

const dishCategoryTagService = new DishCategoryTagService();

function CreateDishCategoryTag() {
  const navigate = useNavigate();

  const [name, setName] = React.useState<string>("");
  const [slug, setSlug] = React.useState<string>("");
  const [iconUrl, setIconUrl] = React.useState<string>("");
  const [isActive, setIsActive] = React.useState<boolean>(true);

  const createTag = async () => {
    if (!name) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Name is required",
        type: CustomSnackbarTypes.ERROR,
      });
      return;
    }

    const payload: any = { name, isActive };
    if (slug) payload.slug = slug;
    if (iconUrl) payload.iconUrl = iconUrl;

    try {
      const res = await dishCategoryTagService.createTag(payload);
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Created Successfully",
        type: CustomSnackbarTypes.SUCCESS,
      });
      navigate(`/DishCategoryTag/${res?.data?.id}/show`);
    } catch (error) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Failed to create dish category tag",
        type: CustomSnackbarTypes.ERROR,
      });
    }
  };

  return (
    <Create title={"Create Dish Category Tag"}>
      <Grid container columns={1} rowSpacing={1} style={{ padding: "12px" }}>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <TextField
              label="Name"
              value={name}
              type="text"
              onChange={(event: any) => setName(event.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <TextField
              label="Slug"
              value={slug}
              type="text"
              onChange={(event: any) => setSlug(event.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <DishCategoryIconUploader
            name={name}
            iconUrl={iconUrl}
            onUploaded={(url) => setIconUrl(url)}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                name="Active"
              />
            }
            label="Active"
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl style={{ width: "230px" }}>
            <Button onClick={createTag} variant="contained">
              Create Tag
            </Button>
          </FormControl>
        </Grid>
      </Grid>
    </Create>
  );
}

export default CreateDishCategoryTag;
